"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var metrics_engine_1 = require("@tableau/metrics-engine");
exports.STATUS_INDICATOR_HEIGHT = 5;
exports.StatusIndicatorBar = function (props) {
    var backgroundColor = backgroundColorForStatusIndicator(props);
    return (React.createElement("div", { style: {
            width: '100%',
            minHeight: exports.STATUS_INDICATOR_HEIGHT,
            backgroundColor: backgroundColor,
        } }));
};
function backgroundColorForStatusIndicator(props) {
    return !props.featureFlags[metrics_engine_1.COLOR_INDICATORS_FLAG] || statusIsNeutralOrUnknown(props.status) ? undefined : props.color;
}
var statusIsNeutralOrUnknown = function (status) {
    if (!status) {
        return true;
    }
    return status === metrics_engine_1.ThresholdStatus.NEUTRAL || status === metrics_engine_1.ThresholdStatus.UNKNOWN;
};
//# sourceMappingURL=StatusIndicatorBar.js.map